import React from 'react'

type SearchHighlightProps = {
  text: string
  searchTerm: string
  className?: string
}

const SearchHighlight = ({ text, searchTerm, className = '' }: SearchHighlightProps) => {
  const parts: (string | JSX.Element)[] = text.split(new RegExp(`(${searchTerm})`, 'gi'))

  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (typeof part === 'string') {
          if (part.toLowerCase() === searchTerm.toLowerCase()) {
            return <mark key={index}>{part}</mark>
          } else {
            return <span key={index}>{part}</span>
          }
        } else {
          return part
        }
      })}
    </span>
  )
}

export default SearchHighlight
